<template>
	<div class="checkout-form__tip">
		<div
			v-if="options.length > 1"
			class="checkout-form__tip-buttons"
		>
			<label
				class="checkout-form__tip-button"
				v-for="(option, index) in options"
				:key="index"
			>
				<input
					class="checkout-form__tip-button-input"
					type="radio"
					:name="uniqueId"
					:value="index"
					v-model="selectedOptionIndex"
					:disabled="locked"
					@input="onSelect(option, index)"
				>
				<span
					class="checkout-form__tip-button-text"
					v-html="option.label"
				/>
			</label>
		</div>
		<FormInputRange
			v-if="selectedOption && selectedOption.range"
			class="checkout-form__tip-input"
			:min="selectedOption.range.min || 0"
			:max="selectedOption.range.max || 100"
			:step="selectedOption.range.step || 1"
			v-model.number="rangeValue"
			hide-value
			:disabled="locked"
		/>
		<div
			v-if="selectedOption && selectedOption.type !== 'none'"
			class="checkout-form__tip-value"
		>
			<span
				v-if="selectedOption.type === 'percent'"
				class="checkout-form__tip-value-percent"
				v-html="`${tipPercent}%`"
			/>
			<span
				class="checkout-form__tip-value-currency"
				v-html="displayValue"
			/>
		</div>
		<div class="additional-info text--highlight"><span v-html="$t('cart.tipMessage')"/> <span v-if="tip" v-html="$t('cart.tipMessageThanks')"/></div>
	</div>
</template>

<script>
import FormInputRange from "@/components/FormInputRange"

export default {
	components: {
		FormInputRange,
	},
	props: {
		options: Array,
		locked: Boolean,
		selected: Number,
		tip: {
			type: Number,
			default: 0
		},
		tipPercent: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			uniqueId: `tip-option-${(Date.now().toString(36) + Math.random().toString(36).substring(2, 7))}`,
			selectedOptionIndex: this.selected,
			rangeValue: 0,
		}
	},
	computed: {
		selectedOption() {
			return this.options.at(this.selectedOptionIndex)
		},
		displayValue() {
			return this.selectedOption?.valueModified ?? this.$options.filters.fwgpricecent(this.tip, 'html')
		}
	},
	watch: {
		rangeValue(value) {
			if (this.selectedOption?.type === 'percent') {
				this.$emit('tip:percent', value)
			} else if (this.selectedOption?.type === 'chf') {
				this.$emit('tip:value', value)
			}
		}
	},
	methods: {
		onSelect(option, index) {
			this.$emit('tip:option', index)

			if (option.range) {
				this.rangeValue = 0
			}

			if (option.value != null) {
				this.$emit('tip:value', option.value)
			} else if (option.percent != null) {
				this.$emit('tip:percent', option.percent)
			}
		},
	},
	mounted() {
		this.options.forEach((option, index) => {
			if (this.selected != null) {
				if (this.selected === index) {
					this.selectedOptionIndex = index
					this.onSelect(option, index)
				}
			}
			else if (option.default) {
				this.selectedOptionIndex = index
				this.onSelect(option, index)
			}
		})
    if (this.options.length === 1) {
      this.onSelect(this.options[0], 0)
    }
	}
}
</script>
